export default __webpack_public_path__ + "static/media/burrataang.e4c07754.avif";